<template>
    <div class="loadtask">
        <el-form  label-position="right" ref="search_form" label-width="110px" :model="form_data" size='large' inline>
            <el-form-item label="商单标题" prop="cpx_order_name">
                <el-input clearable v-model.trim="form_data.cpx_order_name"></el-input>
            </el-form-item>
            <el-form-item label="报名状态" prop="sign_up_time">
                <el-select  v-model="form_data.sign_up_time" clearable placeholder="请选择" class='w-210'>
                <el-option v-for="item in sign_up_time_ary" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="落地投放平台" prop="cpx_client_target_location">
                <el-select v-model="form_data.cpx_client_target_location" clearable placeholder="请选择">
                <el-option v-for="item in luodi_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="客户品牌" prop="cpx_brand_name">
                <el-input clearable v-model.trim="form_data.cpx_brand_name"></el-input>
            </el-form-item>
            <el-form-item label="预计推广时间" prop="time_ary_1" class='time-val'>
                <el-date-picker
                class="w-210"
                :default-time="['00:00:00', '23:59:59']"
                v-model="form_data.time_ary_1"
                :editable="false"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
           
        </el-form>
        <el-form label-width="110px">
            <el-form-item>
                <el-button type="primary" @click="cpxOrderList" size='medium'>搜索</el-button>
                <el-button @click="resetForm" size='medium'>重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
            <el-table-column label="商单信息" width='250'>
                <template slot-scope="scope">
                    <div>
                        <div >商单标题:{{scope.row.cpx_order_name}}</div>
                        <div>创建时间:{{scope.row.create_time}}</div>
                        <div class="flex">报名截止时间:{{scope.row.sign_up_time}}</div>
                        <div>商务对接人：{{scope.row.shangwu_adid_name}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="客户信息" width='200'>
                <template slot-scope="scope">
                    <div>
                    <div>客户品牌：{{scope.row.cpx_brand_name}}</div>
                    <div>投放落地：
                        <span class="daren-tag" v-if="scope.row.cpx_client_target_location_tb === 2">淘宝</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_target_location_tm === 2">天猫</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_target_location_jd === 2">京东自营</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_target_location_jdpop === 2">京东pop</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_target_location_other === 2">其他</span>
                        
                    </div>
                    <div>合作主要目的：
                        <span v-if="scope.row.cpx_client_purpose_p == 1">GMV，</span>
                        <span v-if="scope.row.cpx_client_purpose_p == 2">ROI（利润），</span>
                        <span v-if="scope.row.cpx_client_purpose_p == 3">品宣，</span>
                        <span v-if="scope.row.cpx_client_purpose_s == 1">GMV</span>
                        <span v-if="scope.row.cpx_client_purpose_s == 2">ROI（利润）</span>
                        <span v-if="scope.row.cpx_client_purpose_s == 3">品宣</span>
                    </div>
                    <div>可供样品数：
                        <span v-if="scope.row.cpx_client_sample == 1">足量</span>
                        <span v-if="scope.row.cpx_client_sample == 2">{{scope.row.cpx_client_sample_num}}个</span>
                        <span v-if="scope.row.cpx_client_sample == 3">无</span>
                    </div>
                    <div>佣金方式：
                        <span class="daren-tag" v-if="scope.row.cpx_client_commission_target === 2">定向</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_commission_general === 2">通用</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_commission_sale === 2">营销</span>
                        <span class="daren-tag" v-if="scope.row.cpx_client_commission_other === 2">其他</span>
                    </div>
                    <div>推广预算：{{scope.row.budget_money}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="合作信息" width="250">
                <template slot-scope="scope">
                    <div>
                    <div>合作商品</div>
                    <div>合计：{{scope.row.order_goods_count && scope.row.order_goods_count.total}} (上架{{scope.row.order_goods_count&&scope.row.order_goods_count.confirm}} 下架{{scope.row.order_goods_count&&scope.row.order_goods_count.confirm&&scope.row.order_goods_count.total-scope.row.order_goods_count.confirm}})</div>
                    <div>【待分配】：{{scope.row.order_goods_count.to_assign}}</div>
                    <div>【待审核】：{{scope.row.order_goods_count.to_check}}</div>
                    <div>【审核通过】：{{scope.row.order_goods_count.checked_yes}}</div>
                    <div>【审核不通过】：{{scope.row.order_goods_count.checked_no}}</div>
                    <div>预计推广时间:{{scope.row.expect_begin_time}}至</div>
                    <div>{{scope.row.expect_end_time}}</div>
                    <div>合作达人</div>
                     <div>推荐达人：{{scope.row.cpx_order_kol_count.total}}</div>
                    <div>待审核达人：{{scope.row.cpx_order_kol_count.to_add_coop}}</div>
                    <div>已拒绝达人：{{scope.row.cpx_order_kol_count.deny}}</div>
                    <div>确认合作达人：{{scope.row.cpx_order_kol_count.other}}</div>
                    <div v-if="scope.row.settlement_source==2">结算方式:非联盟（合同等）</div>
                    <div v-if="scope.row.settlement_source==1">结算方式:联盟（星任务/京任务）</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width='150'>
                <template slot-scope="scope">
                    <div>
                    <div class="flex-s">
                        <span>项目状态:</span>
                        <span class="p-color-succ" v-if="scope.row.check_status==1">进行中</span>
                        <span class="p-color-danger mr-4" v-if="scope.row.check_status==2">项目失败</span>
                        <el-tooltip v-if="scope.row.check_status==2" popper-class="item-tooltip" class="item-tooltip" effect="dark" :content="scope.row.check_status_reason" placement="top">
                            <div class="p-text-clamp">
                                <i class="p-color-danger el-icon-question"></i>
                            </div>
                        </el-tooltip>
                        <span class="p-color-succ" v-if="scope.row.check_status==3">项目完成</span>
                        <span class="p-warning" v-if="scope.row.check_status==4">待审核</span>
                        <span class="p-color-danger" v-if="scope.row.check_status==5">审核不通过</span>
                        <el-tooltip v-if="scope.row.check_status==5" popper-class="item-tooltip" class="item-tooltip" effect="dark" :content="scope.row.check_status_reason" placement="top">
                            <div class="p-text-clamp">
                                <i class="p-color-danger el-icon-question"></i>
                            </div>
                        </el-tooltip>
                        <span class="p-color-danger" v-if="scope.row.check_status==6">已取消</span>
                        <el-tooltip v-if="scope.row.check_status==6" popper-class="item-tooltip" class="item-tooltip" effect="dark" :content="scope.row.check_status_reason" placement="top">
                            <div class="p-text-clamp">
                                <i class="p-color-danger el-icon-question"></i>
                            </div>
                        </el-tooltip>
                    </div>
                    <div>
                        <span>报名状态:</span>
                        <span :class="scope.row.sign_up_time_status=='报名中'?'p-color-succ':'p-color-danger'">{{scope.row.sign_up_time_status}}</span>
                    </div>
                    <div v-if="scope.row.settlement_source!=1">
                        <span>达标情况:</span>
                        <span v-if="scope.row.check_complete==1">达标</span>
                        <span v-if="scope.row.check_complete==2">
                            <span>不达标</span>
                            <el-tooltip :content="scope.row.check_complete_reason" popper-class="item-tooltip" effect="dark" placement="top">
                                <i class="p-color-danger el-icon-question"></i>
                            </el-tooltip>
                        </span>
                    </div>
                   
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                     <el-button type='text' size='large'  @click="toPartnerKOl(scope.row)">查看商品/合作达人</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
    </div>
</template>
<script>
import pagePagination from "@/components/page_pagination.vue"
import utils from "@/utils/util.js";

export default {
    name:'cpx_orderlist',
    components: {
        pagePagination
    },
    data(){
        return{
            api: {
                cpxOrderListV2: "home/cpxOrderListV2", 
                getAdidList: "home/getAdidList", 
            },
            list:[],
            sign_up_time_count:0,
            pageData: {
                count: 0,
                page: 1,
                offset: 5
            },
            activeName:'1',
            form_data:{
                cpx_order_name: "",
                sign_up_time: "",
                cpx_client_target_location: '',
                time_ary_1: '',
                expect_begin_time: "",
                expect_end_time: "",
                cpx_brand_name: "",
            },
            check_status_ary: [
                { label: "待审核", value: 4 },
                { label: "审核不通过", value: 5 },
                { label: "进行中", value: 1 },
                { label: "项目失败", value: 2 },
                { label: "项目完成", value: 3 },
                { label: "已取消", value: 6 },
            ],
            sign_up_time_ary: [
                { label: "报名中", value: 2 },
                { label: "已截止", value: 3 }
            ],
            luodi_options: [//落地平台
                { label: "淘宝", value: "tb" },
                { label: "天猫", value: "tm" },
                { label: "京东自营", value: "jd" },
                { label: "京东pop", value: "jdpop" },
                { label: "其他", value: "other" }
            ],
        }
    },
    created(){
        window.scrollTo(0,0)
        this.cpxOrderList()
    },
    methods:{
        cpxOrderList(){
            let _this = this;
            _this.gettime()
            let data = _this.form_data
            data.page = _this.pageData.page;
            data.offset = _this.pageData.offset;
            this.$http({
                method: "POST",
                url: _this.api.cpxOrderListV2,
                data: data
            }).then(res => {
                if (res.code == 1) {
                    _this.list = res.data.list;
                    _this.sign_up_time_count = res.data.sign_up_time
                    _this.list.forEach((item)=>{
                        item.expect_begin_time =(item.expect_begin_time && item.expect_begin_time.split(" ")[0]) || "";
                        item.expect_end_time =(item.expect_end_time && item.expect_end_time.split(" ")[0]) || "";
                        item.sign_up_time = (item.sign_up_time && item.sign_up_time.split(" ")[0]) || "";
                    })
                    _this.pageData.count = res.data.count
                } else {
                    this.$message.warning(res.msg);
                }
            })
        }, 
        gettime(){
            console.log('aaaa',this.form_data.time_ary_1)
                this.form_data.expect_begin_time = this.form_data.time_ary_1 !=""? utils.dateFormat(new Date(this.form_data.time_ary_1[0])).full :''
                this.form_data.expect_end_time = this.form_data.time_ary_1!="" ? utils.dateFormat(new Date(this.form_data.time_ary_1[1])).full :''
        }, 
        // 查看商品合作达人
        toPartnerKOl(row){
            this.$router.push({name:'partner_info',query:{
                cxorid:row.cxorid
                }
            })
        },
        resetForm(){
            this.$refs.search_form.resetFields()
        },
        // 分页改变
        pageChange(page, pageSize){
            this.pageData.page = page;
            this.pageData.offset = pageSize;
            this.cpxOrderList();
        }
    }
}
</script>
<style scoped>
.w192{
    width: 192px;
}
.w-210{
    width:210px;
}
.tag{
    margin-right: 5px;
}
.flex{
    display: flex;
}
.w110{
    width: 130px;
}
.mr-4{
    margin-right:4px;
}
.w-70{
    width: 120px;
}
.btn-tab {
  margin-bottom: 10px;
}
.btn-tab button {
  padding: 9px 11px;
  color: #666;
}
.self-divider {
  margin: 20px 0;
  background-color: #DEDEDE;
}
</style>